/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gender: "f" | "m" }} All_SelectedInputs */



/**
* | gender | output |
* | --- | --- |
* | "f" | "All selected" |
* | "m" | "All selected" |
*
* @param {All_SelectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const all_selected = /** @type {((inputs: All_SelectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_SelectedInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.gender === "f") return /** @type {LocalizedString} */ (`All selected`);
		if (i?.gender === "m") return /** @type {LocalizedString} */ (`All selected`);
		return /** @type {LocalizedString} */ ("all_selected");
	}
	{
		if (i?.gender === "f") return /** @type {LocalizedString} */ (`Toutes sélectionnées`);
		if (i?.gender === "m") return /** @type {LocalizedString} */ (`Tous sélectionnés`);
		return /** @type {LocalizedString} */ ("all_selected");
	}
});